import { useRef } from 'react';
import PropTypes from 'prop-types';

import { Text } from '@cof/plastic-components';
import { css, styled } from 'styled-components';

import BaseLinkButton from '../LinkButton';
import { useController } from 'react-hook-form';

export const AddressListContainer = styled.div`
    ${({ theme }: any) => css`
        ${theme.components.Field}
        margin-bottom: ${theme.space.sm};
    `};
`;
AddressListContainer.displayName = 'AddressListContainer';

export const ListWrapper = styled.ul`
    ${({ theme }: any) => css`
        max-height: 32rem;
        border: 0.1rem solid
            ${({ $hasErrors }: any) => ($hasErrors ? theme.colors.capitalOne.red550 : theme.colors.global.grey200)};
        overflow-y: auto;
        padding: ${theme.space.xs};

        & label {
            border-bottom: 0.1rem solid ${theme.colors.global.grey100};
        }
    `};
`;
ListWrapper.displayName = 'ListWrapper';

export const ListItem = styled.li`
    ${({ theme }: any) => css`
        list-style: none;
        position: relative;

        &::after {
            border-bottom: 1px solid ${theme.colors.global.grey50};
            content: '';
            left: ${theme.space.sm};
            position: absolute;
            top: 100%;
            width: calc(100% - ${theme.space.sm}*2);
        }

        &:last-of-type::after {
            display: none;
        }
    `};
`;
ListItem.displayName = 'ListItem';

export const LinkButton = styled(BaseLinkButton)`
    ${({ theme }: any) => css`
        padding: calc(${theme.space.md} / 2) ${theme.space.sm};
        position: relative;
        text-align: left;
        width: 100%;

        &:focus {
            text-decoration: none;
        }
    `};
`;
LinkButton.displayName = 'LinkButton';

const AddressList = ({ id, label, options, onAddressSelect }: any) => {
    const { field, fieldState } = useController({
        name: id,
        defaultValue: ''
    });
    const error = fieldState?.error;
    const isTouched = fieldState?.isTouched;

    const { name } = field;
    // @ts-expect-error TS2554: Expected 1 arguments, but got 0.
    const inputRadioRef = useRef();
    // @ts-expect-error TS2554: Expected 1 arguments, but got 0.
    const fieldContainerRef = useRef();
    const onSelect = (selectedOptionValue: any) =>
        onAddressSelect(options.find((option: any) => option.formattedAddress === selectedOptionValue));
    return (
        // @ts-expect-error TS2769: No overload matches this call.
        <AddressListContainer ref={fieldContainerRef} data-qa-id={`${id}-container`}>
            <p aria-live="polite" role="alert" data-qa-id={`${id}-label`} data-qm-allow="true">
                {label}
            </p>
            {/* @ts-expect-error TS2769: No overload matches this call. */}
            <ListWrapper role="group" id={id} data-qa-id={id} $hasErrors={error && isTouched}>
                {options.map((option: any, index: any) => (
                    <ListItem key={option.formattedAddress}>
                        <LinkButton
                            id={`${name}-radio-button-${index}-input`}
                            data-qa-id={`${option.formattedAddress}-button`}
                            // @ts-expect-error TS2769: No overload matches this call.
                            ref={index === 0 ? inputRadioRef : undefined}
                            value={option.formattedAddress}
                            onClick={() => onSelect(option.formattedAddress)}
                        >
                            <Text>{option.formattedAddress}</Text>
                        </LinkButton>
                    </ListItem>
                ))}
            </ListWrapper>
        </AddressListContainer>
    );
};
AddressList.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            houseNumber: PropTypes.string,
            postTown: PropTypes.string,
            formattedAddress: PropTypes.string.isRequired
        })
    ).isRequired,
    onAddressSelect: PropTypes.func.isRequired
};

export default AddressList;
